import React from "react";
import "./experience.css";
import css3 from '../../assets/css3.png'
import html from '../../assets/html-5.png'
import js from '../../assets/javascript.png'
import react from '../../assets/react.png'
import bs from '../../assets/bootstrap.png'
import tailwind from '../../assets/tailwind.jpg'
import node from '../../assets/node.jpg'
import express from '../../assets/ExpressJs.png'
import mongodb from '../../assets/mongodb.png'
import php from '../../assets/php.png'
import mysql from '../../assets/mysql.png'
import c from '../../assets/c.png'
import csharp from '../../assets/csharp.png'
import java from '../../assets/java.png'
import python from '../../assets/python.png'
import cplusplus from '../../assets/c++.png'

const Experience = () => {

  return (
    <section id="experience" data-aos="zoom-out-up">
      <h5>What Skills I Have</h5>
      <h2>My Skills</h2>
      <div className="container experience_container">
       
        <div className="experience_frontend">
          <h3>Frontend Development</h3>
          <div className="experience_content">
            <article className="experience_details">
              <img src={html} className="experience_details-icon" alt="html"/>
              <div>
                <h4>Html5</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <img src={css3} className="experience_details-icon" alt="css"/>
              <div>
               
                <h4>Css3</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <img src={js} className="experience_details-icon" alt="js"/>
              <div>
                <h4>JavaScript</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <img src={react} className="experience_details-icon" alt="react"/>
              <div>                
                <h4>React & Redux</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <img src={bs} className="experience_details-icon" alt="bs"/>
              <div>           
                <h4>Bootstrap</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <img src={tailwind} className="experience_details-icon" alt="tailwind"/>
              <div>
               
                <h4>Tailwind</h4>
                <small className="text-light">Beginner</small>
              </div>
            </article>
          </div>
        </div>
        <div className="experience_backend">
          
          <h3>Backend Development</h3>
          <div className="experience_content">
            <article className="experience_details">
              <img src={express} className="experience_details-icon" alt="ExpressJS"/>
              <div>
               
                <h4>Express</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <img src={mongodb} className="experience_details-icon" alt="mongodb"/>
              <div>
                <h4>MongoDB</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <img src={mysql} className="experience_details-icon" alt="mysql"/>
              <div>
             
                <h4>MySQL</h4>
                <small className="text-light">Beginner</small>
              </div>
            </article>
            <article className="experience_details">
              <img src={php} className="experience_details-icon" alt="php"/>
              <div>
                <h4>Php</h4>
                <small className="text-light">Beginner</small>
              </div>
            </article>
            <article className="experience_details">
              <img src={node} className="experience_details-icon" alt="node"/>
              <div>
                <h4>Node.js</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
          </div>
        </div>
  
            <div className="experience_programmer ">
          
          <h3>Programming Language</h3>
          <div className="experience_content">
            <article className="experience_details">
              <img src={java} className="experience_details-icon" alt="java"/>
              <div>
               
                <h4>Java</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <img src={python} className="experience_details-icon" alt="python"/>
              <div>
                <h4>Python</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <img src={c} className="experience_details-icon" alt="c"/>
              <div>
             
                <h4>C</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
            <img src={csharp} className="experience_details-icon" alt="C#"/>
              <div>
             
                <h4>C#</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
            <img src={cplusplus} className="experience_details-icon" alt="C++"/>
              <div>
             
                <h4>C++</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
          </div>
             </div>
      
        

      </div>
    </section>
  );
};

export default Experience;
